import React, { Component } from "react";

import { Pagination } from "react-bootstrap";

import * as constants from "../../config/constants/AppConstants";

const UI_SIZE = constants.AppSettings.UI_SIZE;

class CommonPagination extends Component {
    constructor(props) {
        super(props);
    }

    render = () => {

        const { handlePagination } = this.props;

        const { currentPage, pageSize, sectionSize, totalRows } = this.props.Pagination;

        const totalPages = Math.ceil(totalRows / pageSize);
        const currentSection = Math.ceil(currentPage / sectionSize);
        const startPage = (currentSection - 1) * sectionSize + 1;
        const endPage = Math.min(startPage + sectionSize - 1, totalPages);

        return (
            <nav className="pagination-wrap justify-content-end mb-3">
                <Pagination className="custom-pagination pagination-rounded" size={UI_SIZE}>
                  
                    {currentPage > sectionSize && (
                        <Pagination.Prev onClick={() => { handlePagination({direction: "prev"}); } }>
                            <i className="fa-classic fa-light fa-chevron-left fa-fw" />
                        </Pagination.Prev>
                    )}

                    {Array.from({ length: endPage - startPage + 1 }, (_, index) => {
                        const page = startPage + index;
                        return (
                            <Pagination.Item
                                key={page}
                                active={page === currentPage}
                                onClick={() => { handlePagination({page: page})}}
                            >
                                {page}
                            </Pagination.Item>
                        );
                    })}

                    {currentPage + sectionSize <= totalPages && (
                        <Pagination.Next onClick={() => { handlePagination({direction: "next"}); }}>
                            <i className="fa-classic fa-light fa-chevron-right fa-fw" />
                        </Pagination.Next>
                    )}

                </Pagination>
            </nav>
        );
    }
}

export default CommonPagination;
